import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IModuleCustomSettingSection, ModuleCustomSettingSectionType } from 'src/shared/models/module-custom-settings-section.model';
import { ModuleManager } from 'src/shared/models/module-manager';

@Directive({
    selector: '[cvModuleCxoneCustomSettingSection]'
})
export class ModuleCxoneCustomSettingSectionDirective implements OnInit, AfterViewInit, OnDestroy, IModuleCustomSettingSection {
    @Input() moduleManager: ModuleManager;
    @Input() after?: string;
    @Input() inside?: string;

    type = ModuleCustomSettingSectionType.CxOne;
    private _subscription: Subscription = null;

    constructor(private element: ElementRef<HTMLElement>) {

    }

    getNativeElement(): HTMLElement {
        return this.element.nativeElement;
    }

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {
        this._subscription = this.moduleManager.slideoutSettingsManager.subscribe(manager => {
            manager?.placeCustomSettings(this);
        });
    }

    ngOnDestroy() {
        this._subscription?.unsubscribe();
    }
}
